import React from 'react';
import './assets/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Import context providers
import { AuthProvider, useAuth } from './context/AuthContext';

// Import layout components
import Layout from './components/Layout';

// Import pages
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import CampaignsPage from './pages/CampaignsPage';
import ManualCallsPage from './pages/ManualCallsPage';
import ScriptsPage from './pages/ScriptsPage';
import AsteriskConfigPage from './pages/AsteriskConfigPage';
import ConversationsPage from './pages/ConversationsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import VoiceAIPage from './pages/VoiceAIPage';
import SettingsPage from './pages/SettingsPage';
import Mvp from './pages/Mvp';

// Protected Route wrapper component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // Or a proper loading component
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Main App component
const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Public route */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout><Dashboard /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/campaigns"
              element={
                <ProtectedRoute>
                  <Layout><CampaignsPage /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/script"
              element={
                <ProtectedRoute>
                  <Layout><ScriptsPage /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/calls"
              element={
                <ProtectedRoute>
                  <Layout><ManualCallsPage /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/manual-calls"
              element={
                <ProtectedRoute>
                  <Layout><ManualCallsPage /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/conversations"
              element={
                <ProtectedRoute>
                  <Layout><ConversationsPage /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <ProtectedRoute>
                  <Layout><AnalyticsPage /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/voices"
              element={
                <ProtectedRoute>
                  <Layout><VoiceAIPage /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/asterisk-config"
              element={
                <ProtectedRoute>
                  <Layout><AsteriskConfigPage /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Layout><SettingsPage /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/mvp"
              element={<Mvp />}
            />
            
            {/* Redirect unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          {/* Toast notifications */}
          <ToastContainer position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;